var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-form-checkbox",
            {
              staticClass: "pb-1",
              model: {
                value: _vm.model.render,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "render", $$v)
                },
                expression: "model.render",
              },
            },
            [_vm._v("\n      Skew\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.model.render
        ? [
            _c(
              "b-col",
              { attrs: { cols: "6" } },
              [
                _c("label", { staticClass: "mb-1 small" }, [
                  _vm._v("Left Top"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "X",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.tl[0].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("tl", 0, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "Y",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.tl[1].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("tl", 1, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { cols: "6" } },
              [
                _c("label", { staticClass: "mb-1 small" }, [
                  _vm._v("Right Top"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "X",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.tr[0].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("tr", 0, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "Y",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.tr[1].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("tr", 1, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { cols: "6" } },
              [
                _c("label", { staticClass: "mb-1 small" }, [
                  _vm._v("Bottom Left"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "X",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.bl[0].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("bl", 0, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "Y",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.bl[1].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("bl", 1, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { cols: "6" } },
              [
                _c("label", { staticClass: "mb-1 small" }, [
                  _vm._v("Bottom Right"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "X",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.br[0].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("br", 0, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    attrs: {
                      label: "Y",
                      "label-cols-sm": "2",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "form-control-sm",
                      attrs: {
                        value: _vm.br[1].toFixed(2),
                        type: "number",
                        size: "sm",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onChangeCoords("br", 1, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }